/* eslint-disable jsx-a11y/control-has-associated-label */
import { useEffect, useState } from "react";
import { Edit2, Trash } from "react-feather";
import Table, { TableHeading } from "../../../../shared/Table/Table";
import DeleteModal from "../../../../shared/DeleteModal/DeleteModal";
import {
  RootStore,
  useAppDispatch,
  useAppSelector,
} from "../../../../store/store";
import {
  deleteVideoTourVideo,
  getVideoFromBunnyNet,
} from "../../../../store/features/AdminPanel/VideoTour/VideoTourApi";
import { editUploadedVideo, setSlug } from "../../../../store/features/AdminPanel/VideoTour/VideoTourSlice";
import { formatTitle } from "../VideoTourHeader/helper";

function VideoTourBody(props: any) {
  const [showDeleteModal, setDeleteShowModal] = useState(false);
  const dispatch = useAppDispatch();
  const videoTourState: any = useAppSelector(
    (store: RootStore) => store.VideoTourSlice
  );

  useEffect(() => {
    dispatch(getVideoFromBunnyNet());
  }, []);

  useEffect(() => {
    if (
      !videoTourState?.is_loading.delete &&
      videoTourState?.is_success.delete
    ) {
      setDeleteShowModal(false);
      dispatch(getVideoFromBunnyNet());
    }
  }, [videoTourState]);

  const handleEditVideo = (data:any) => {
    // console.log(data);
    
    dispatch(editUploadedVideo({data,isTrue:true}));
  };
  const openDeleteModal = (item:any)=>{
     dispatch(setSlug({slug:item?.slug}))
    setDeleteShowModal(true)
  }

  const handleDeleteVideo = () => {
    dispatch(deleteVideoTourVideo({slug:videoTourState?.slug}));
  };

  const truncateString = (str: any, num: any) => {
    if(!str){
      return "-"

    }
    if (str?.length <= num) {
      return str;
    }
    return `${str?.slice(0, num)}...`;
  };

  return (
    <div className="testimonialbody">
      <Table
        heading={
          <TableHeading>
            <th>Title</th>
            <th>Video Url/ID</th>
            <th>For</th>
            <th className="">Status</th>
            <th className="hide__text">.</th>
          </TableHeading>
        }
      >
        <tbody>
          {videoTourState?.video_data &&
            videoTourState?.video_data?.map((item:any) => (
              <tr className="ttr" key={item.id}>
                <td className="ttd ttd_name">
                  {item.content?.title || "-"}
                </td>
                <td className="ttd">
                  {truncateString(
                    item.content?.video_url
                      ? item.content?.video_url
                      : item.content?.videoId?.toString(),
                    100
                  )}
                </td>
                <td className="">
                 {formatTitle(item?.slug)}
                </td>
                <td className="">
                  {item.content?.show
                    ? "Active"
                    : "Not Active"}
                </td>
                <td className="ttd ttd_action">
                  <Edit2
                    className="edit__icon"
                    onClick={() => handleEditVideo(item)}
                  />
                  <Trash
                    className="delete__icon"
                    onClick={() => {
                     openDeleteModal(item)
                    }}
                  />
                </td>
              </tr>
            ))}
        </tbody>
      </Table>

      <DeleteModal
        showModal={showDeleteModal}
        setShowModal={setDeleteShowModal}
        onClick={handleDeleteVideo}
        loading={
          videoTourState?.is_loading.delete &&
          !videoTourState?.is_success.delete
        }
      />
    </div>
  );
}

export default VideoTourBody;
